<template>
  <div class="log-register">
    <div class="log-register__header">
      <h2 class="log-register__title">{{ content.title }}</h2>
    </div>

    <div class="log-register__form">
      <div class="form-box">
        <form v-loading="isLoading" class="form-box__form" @submit.prevent="onSubmit">
          <form-box-input
            :label="$t('first_name')"
            type="text"
            v-model="form.name"
          />

          <form-box-input
            label="Email"
            type="text"
            v-model="form.email"
          />

          <form-box-input
            :label="$t('telephone')"
            type="tel"
            placeholder="+7 (999) 999 99 99"
            :message="errors.phone ? errors.phone : ''"
            :hasError="errors.form || errors.phone"
            v-mask="`+7 (###) ### ## ##`"
            v-model="form.phone"
          />


          <form-box-input
            :label="$t('description')"
            type="textarea"
            v-model="form.question"
          />

          <base-button type="submit" tabindex="0" class="form-box__button" :disabled="isDisabled">{{
              $t('send')
            }}
          </base-button>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import FormBoxInput from '@/components/form/FormBoxInput';
import BaseButton from '@/components/ui/BaseButton';

export default {
  name: 'FeedbackPage',

  components: {
    FormBoxInput,
    BaseButton
  },

  data() {
    return {
      isLoading: false,
      form: {
        name: '',
        email: '',
        phone: '',
        question: ''
      },
      initialForm: {
        name: '',
        email: '',
        phone: '',
        question: ''
      },
      content: {
        title: 'Обратная связь',
        // eslint-disable-next-line max-len
        note: this.$t('register_using_phone_number')
      },
      errors: {
        form: false
      },
      loginIsFocus: false,
      passwordIsFocus: false,
      error: '',
      showPopover: false
    };
  },

  computed: {
    isDisabled() {
      return !this.form.name || !this.form.phone || !this.form.email || !this.form.question;
    }
  },

  methods: {

    onSubmit() {
      this.isLoading = true;

      this.$notify.success({
        position: 'top-right',
        title: this.$t('success'),
        message: this.$t('send_message')
      });

      this.isLoading = false;

      this.form = this.initialForm
    }
  }

};
</script>

<style lang="sass" scoped>
@import "../sass/variables"
@import "../sass/mixins"
@import "../sass/pages/login-register"
@import "../sass/components/form/form"
@import "../sass/components/form/form"

.form-box__button--forgot-password
  position: relative
  z-index: 2

  .underline
    position: relative

    &::after
      +Size(100%, 0)
      display: block
      border-bottom: 1px dashed $cAccent

      position: absolute
      left: 0
      bottom: 0

      content: ''
</style>
